import { Container, Box, DialogContent, DialogActions } from "@mui/material";
import { Alert, Button } from "@platform/design-system";

import NewClientForm from "../../components/clientFormNew";
import { Loader } from "../../components";
import { extractErrorMessage } from "../../utils";
import { CLIENT_REDUCER_ACTIONS } from "../../constants/client";

const { UPDATE_CLIENT_FIELD } = CLIENT_REDUCER_ACTIONS;

function ClientDialogContent({
  disabled,
  isSubmit,
  clientForm,
  setClientForm,
  prepareClientFormState,
  submitText,
  onSubmit,
  onCancel,
  showClientInformationLabel,
}) {
  function handleChange({ target }) {
    const { value, name } = target;
    setClientForm({ type: UPDATE_CLIENT_FIELD, name, value });
  }

  return (
    <>
      <DialogContent sx={{ paddingY: 0 }}>
        {prepareClientFormState.loading ? (
          <Container sx={{ my: 5 }}>
            <Loader />
          </Container>
        ) : prepareClientFormState.data ? (
          <NewClientForm
            showClientInformationLabel={showClientInformationLabel}
            client={clientForm}
            onChange={handleChange}
            {...prepareClientFormState.data}
          />
        ) : prepareClientFormState.error ? (
          <Box mt={2} mb={2}>
            <Alert severity="error">
              {extractErrorMessage(prepareClientFormState.error)}
            </Alert>
          </Box>
        ) : null}
      </DialogContent>
      <DialogActions>
        <Button
          data-testid="client-form-cancel"
          disabled={prepareClientFormState.loading || isSubmit}
          variant="tertiary"
          onClick={onCancel}
        >
          CANCEL
        </Button>
        <Button
          data-testid="client-form-submit"
          disabled={prepareClientFormState.loading || disabled}
          variant="primary"
          loading={isSubmit}
          onClick={onSubmit}
        >
          {submitText}
        </Button>
      </DialogActions>
    </>
  );
}

export default ClientDialogContent;
